import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {getCompanyTimecard} from "../common/api/WebApi";
import {Card, CardContent, Grid} from "@mui/material";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import MDTypography from "../../components/MDTypography";
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import MDButton from "../../components/MDButton";
import Loading from "../common/Loading";
import DataTable from "react-data-table-component";
import BootyPagination from "../common/bootyPagination";
import {getCookie, setCookie} from "../common/appCookie";
import * as pagination from "../common/pagination";
import {formatDate, formatDateMask, formatDateTime} from "../common/Utils";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";

export default function Timesheets(props) {
  const navigate = useNavigate();

  const [context, setContext] = useContext(AppContext);

  const [saving, setSaving] = useState(false);
  const [manageEmployee, setManageEmployee] = useState(false);
  const [employee, setEmployee] = useState({});
  const [employees, setEmployees] = useState([]);
  const [timecards, setTimecards] = useState([]);
  const [timecardsLoading, setTimecardsLoading] = useState(true);

  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);

  useEffect(() => {
    runReport();
  }, []);

  const totalTime = (input) => {
    let start = moment(input.startDate);
    let end = moment(input.endDate);
    let duration = moment.duration(end.diff(start));
    return duration.asMinutes();
  }

  const displayTime = (input) => {
    let start = moment(input.startDate);
    let end = moment(input.endDate);
    let duration = moment.duration(end.diff(start));
    let minutes = duration.asMinutes();

    let hours = Math.floor(minutes / 60);
    let hourMins = minutes % 60;
    return hours + ' Hours' + (hourMins > 0 ? ' ' + hourMins + ' mins' : '');
  }

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const runReport = () => {
    const _req = {
      startDate: startDate,
      endDate: endDate
    }
    setTimecardsLoading(true);
    getCompanyTimecard(_req).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setTimecards(result?.timecardEntryList);
        setTimecardsLoading(false);
      }
    });
  }

  const myRefs = useRef([]);
  const [renderIndex, setRenderIndex] = useState(1);

  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };

  const _columns = [
    {
      name: <span className='th'>Employee</span>,
      id: 1,
      selector: row => row.employee?.lastName?.toUpperCase(),
      cell: row => {
        let link = '/company/employees/view/' + row.employee?.guid;
        return <a href={link}>{row.employee?.lastName + ', ' + row.employee?.firstName}</a>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Start</span>,
      id: 2,
      selector: row => row.startDate,
      cell: row => {
        return <>{formatDateTime(row.startDate)} </>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>End</span>,
      id: 3,
      selector: row => row.endDate,
      cell: row => {
        return <>{formatDateTime(row.endDate)} </>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Total</span>,
      id: 4,
      selector: row => totalTime(row),
      cell: row => {
        return <>{displayTime(row)} </>;
      },
      sortable: true,
    },
  ];

  const [columns, setColumns] = useState(_columns);

  const handleSort = (sorted, sortDir) => {
    setCookie('TIMECARD_SORT', sorted.id);
    setCookie('TIMECARD_SORT_DIR', sortDir);
  }

  const exportCsv = () => {
    let d = [...timecards];
    let filename = 'Timesheet-Export-' + formatDate(startDate, 'MM-dd-yyyy') + '-' + formatDateMask(endDate, 'MM-dd-yyyy') + '.csv';

    let rows = [];
    let _dd = [];
    _dd.push("Employee Last Name");
    _dd.push("Employee First Name");
    _dd.push("Reference Id");
    _dd.push("Start");
    _dd.push("End");
    _dd.push("Total");

    rows.push(_dd);

    for (let j in d) {
      let _dd = [];
      _dd.push(d[j].employee?.lastName);
      _dd.push(d[j].employee?.firstName);
      _dd.push(d[j].employee?.guid);
      _dd.push(formatDateTime(d[j].startDate));
      _dd.push(formatDateTime(d[j].endDate));
      _dd.push(displayTime(d[j]));

      rows.push(_dd);
    }

    let data = rows.map(row =>
      row
        .map(String)  // convert every value to String
        .map(v => v.replaceAll('"', '""'))  // escape double quotes
        .map(v => `"${v}"`)  // quote it
        .join(',')  // comma-separated
    ).join('\r\n');

    var blob = new Blob([data], {type: 'text/csv;charset=utf-8;'});
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  const displayTotal = (timeIn) => {
    const minutes = timeIn;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours} Hours ${remainingMinutes} mins`
  }

  const timeCardTotals = (data) => {
    const grouped = new Map();
    for (let j in data) {
      const id = data[j].employee.guid;
      const employee = data[j].employee;
      const value = totalTime(data[j]);
      if (grouped.has(id)) {
        grouped.get(id).value += value;
      } else {
        grouped.set(id, {value, employee});
      }
    }
    return grouped;
  }


  return (
    <DashboardLayout>

      <Meta pageTitle={'Time Sheets'}/>

      <ContextSearchNavbar title={'Time Sheets'}/>
      <MDBox py={3}>
        <Grid container>
          <Grid item xs={12} mb={2}>

            <DesktopDatePicker
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '4px 0 0 4px'
                }
              }}
              closeOnSelect={false}
              maxDate={dayjs()}
              slotProps={{
                actionBar: {
                  actions: ['today', 'accept'],
                },
              }}
              value={dayjs(startDate)}
              onChange={(e) => {
                setStartDate(e?.$d);
              }}
            />
            <DesktopDatePicker
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '4px 0 0 4px'
                }
              }}
              closeOnSelect={false}
              minDate={dayjs(startDate)}
              maxDate={dayjs()}
              slotProps={{
                actionBar: {
                  actions: ['today', 'accept'],
                },
              }}
              value={dayjs(endDate)}
              onChange={(e) => {
                setEndDate(e?.$d)
              }}
            />
            <MDButton
              sx={{
                borderRadius: '0 4px 4px 0',
                height: '100%'
              }}
              color="info"
              onClick={() => {
                runReport();
              }}
            >Go</MDButton>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Card>
                <MDBox p={3}>

                  <MDButton
                    className="pull-right"
                    color="secondary"
                    size="small"
                    onClick={exportCsv}><span className="fa fa-file-excel"></span>&nbsp;Export</MDButton>

                  <Grid>
                    {timecardsLoading && <Loading/>}
                    <Grid item xs={12} sm={12}>
                      {!timecardsLoading && <DataTable
                        striped
                        noDataComponent={<MDTypography variant={'p'} className={'cursor-default'}
                                                       fontWeight={'light'}>No
                          Time Entries Found</MDTypography>}
                        columns={columns}
                        keyField={'guid'}
                        data={timecards}
                        onSort={handleSort}
                        highlightOnHover
                        onRowClicked={(row) => {
                        }}
                        paginationComponent={BootyPagination}
                        paginationTotalRows={timecards.length}
                        progressPending={timecardsLoading}
                        defaultSortFieldId={getCookie('TIMECARD_SORT') || 2}
                        defaultSortAsc={getCookie('TIMECARD_SORT_DIR') === 'desc' ? false : true}
                        paginationComponentOptions={PaginationOptions}
                      />}
                    </Grid>
                  </Grid>

                </MDBox>
              </Card>
            </Grid>

            {!timecardsLoading && <Grid item sm={4} xs={12}>
              <Card>
                <CardContent sx={{}}>
                  <MDTypography variant="h5" fontWeight={"light"}>
                    Time Sheet Totals
                    &nbsp;
                  </MDTypography>
                  <table className={'table table-striped table-hover'}>
                    <thead>
                    <tr>
                      <th>Employee</th>
                      <th>Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    {Array.from(timeCardTotals(timecards))
                      .sort((a, b) => a[1].employee.lastName.localeCompare(b[1].employee.lastName))
                      .map(([key, value]) => {
                        return (
                          <tr key={key}>
                            <td>
                              <a href={'/company/employees/view/' + value.employee.guid}>
                                {value.employee.lastName}, {value.employee.firstName}
                              </a>
                            </td>
                            <td >{displayTotal(value.value)}</td>
                          </tr>
                        )
                      })
                    }
                    </tbody>
                  </table>

                </CardContent>
              </Card>
            </Grid>
            }
          </Grid>

        </Grid>
      </MDBox>

      <Footer mt={5}/>

    </DashboardLayout>
);
}